import { Sparkles } from 'lucide-react';
import clsx from 'clsx';

/**
 * Visual marker for content generated by an LLM. Apply to recommendations,
 * outlines, briefs, suggestions — anywhere we want the user to know the
 * output came from AI (vs. their own input or deterministic site scans).
 */
export default function AIBadge({ label = 'AI-generated', size = 'sm', className = '' }) {
  const sizes = {
    sm: 'text-[10px] px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5',
  };
  const icon = size === 'md' ? 'w-3.5 h-3.5' : 'w-3 h-3';
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-semibold tracking-wide',
        'bg-gradient-to-r from-brand-500/10 to-cyan-500/10 text-brand-700',
        'ring-1 ring-brand-200/60',
        sizes[size],
        className,
      )}
    >
      <Sparkles className={icon} strokeWidth={2} />
      {label}
    </span>
  );
}
